export default __webpack_public_path__ + "static/media/09.9a9f7b22.png";